import type { LineupTabResponse } from '../../types';

export function isLineupTabEmpty(data: LineupTabResponse): boolean {
  const sideHasNoPlayers = (side: LineupTabResponse['home']) =>
    side.bench.length === 0 && side.lines.every((row) => row.length === 0);

  return sideHasNoPlayers(data.home) && sideHasNoPlayers(data.away);
}
